import NovalueCheck from './NoValueCheck';

export default (value) => {
  if(NovalueCheck(value)) return NovalueCheck(value);

  value = +value;

  // ค่าปกติ: 18.5 - 22.9 (สำหรับคนเอเชีย)
  // ผิดปกติ: < 18.5 หรือ >= 23

  if(value >= 18.5 && value < 23) {
    return {
      title: 'BMI ปกติ',
      color: 'green',
      caption: 'น้ำหนักอยู่ในเกณฑ์ปกติ',
      suggest: ''
    };
  } else {
    return {
      title: 'BMI ผิดปกติ',
      color: 'red',
      caption: value < 18.5 ? 'น้ำหนักน้อยกว่าเกณฑ์ปกติ' : 'น้ำหนักเกินหรือมีภาวะอ้วน',
      suggest: 'แนะนำให้ปรึกษาแพทย์หรือนักโภชนาการ'
    };
  }
}